import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductPriceComponent } from './product-price.component';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [ProductPriceComponent],
  imports: [CommonModule, PipesModule],
  exports: [ProductPriceComponent],
})
export class ProductPriceModule {}
